import React from 'react';
import { Link } from 'react-router-dom';
import LogoBlack from '../assets/images/Name_Black.png';

const Footer = () => {

  return (
    <footer>
      <div className="footer-top footer-top-responsive">
        <div className="container">
          <div className="footer-brand-wrapper footer-brand-responsive">
            <a href="/" className="logo">
              <img src={LogoBlack} alt="Oracle Gaming logo" />
            </a>

            <div className="footer-menu-wrapper">
              <ul className="footer-menu-list" style={{justifyContent: 'center', width: '100%'}}>
                <li>
                  <Link to="/" className="footer-menu-link">Home</Link>
                </li>
                <li>
                  <Link to="/shop" className="footer-menu-link">Shop</Link>
                </li>
                <li>
                  <Link to="/shop?brand=Pokemon" className="footer-menu-link">Pokemon</Link>
                </li>
                <li>
                  <Link to="/shop?brand=One%20Piece" className="footer-menu-link">One Piece</Link>
                </li>
                <li>
                  <Link to="/shop?category=Singles" className="footer-menu-link">Singles</Link>
                </li>
                <li>
                  <Link to="/shop?onSale=true" className="footer-menu-link">Sale</Link>
                </li>
                <li>
                  <a href="/#tournament" className="footer-menu-link">Tournaments</a>
                </li>
                <li>
                  <Link to="/contact" className="footer-menu-link">Contact</Link>
                </li>
              </ul>

              <div className="footer-social-wrapper">
                <ul className="footer-social-list">
                  <li>
                    <a href="https://wa.me/27825655408" target="_blank" rel="noopener noreferrer" className="footer-social-link" title="WhatsApp">
                      <ion-icon name="logo-whatsapp"></ion-icon>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/oraclegamingza?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="footer-social-link" title="Instagram">
                      <ion-icon name="logo-instagram"></ion-icon>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/p/Oracle-Gaming-100085081547257/" target="_blank" rel="noopener noreferrer" className="footer-social-link" title="Facebook">
                      <ion-icon name="logo-facebook"></ion-icon>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Copyright and Legal Links */}
          <div className="footer-copyright-section footer-copyright-responsive">
            <p className="copyright copyright-responsive">
              © 2025 ORACLE GAMING. ALL RIGHTS RESERVED. Website designed & hosted by <a href="https://kaizentech.co.za/" target="_blank" rel="noopener noreferrer" className="kaizen-link">Kaizen Technology</a>
            </p>
            <div className="footer-legal-links legal-links-responsive">
              <Link to="/privacy" className="legal-link">Privacy Policy</Link>
              <span className="legal-separator">|</span>
              <Link to="/shipping-policy" className="legal-link">Shipping Policy</Link>
              <span className="legal-separator">|</span>
              <Link to="/returns-policy" className="legal-link">Returns Policy</Link>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
